export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    load: (state, data) => {
      for (const i in data) {
        const dataTeam = data[i]

        const newTeam = {
          id: dataTeam.id,
          name: dataTeam.nameFr
        }

        const foundTeam = state.list.find((team) => { return team.id === newTeam.id })
        if (foundTeam) {
          Object.assign(foundTeam, newTeam)
        } else {
          state.list.push(newTeam)
        }
      }
    }
  },
  getters: {
    team: (state) => (teamId) => state.list.find((team) => { return team.id === teamId })
  }
}
